var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{directives:[{name:"show",rawName:"v-show",value:(_vm.page.show_intro),expression:"page.show_intro"}],staticClass:"mb-6",class:_vm.align},[_c('div',{class:{
      'flex flex-col-reverse sm:flex-row sm:justify-between sm:items-center':
        _vm.$slots['header-content'],
    }},[_c('h1',{staticClass:"text-3xl md:text-4xl"},[_vm._v(_vm._s(_vm.render(_vm.page.title)))]),_vm._v(" "),_vm._t("header-content")],2),_vm._v(" "),(_vm.page.intro_text)?_c('div',{staticClass:"mb-6 mt-2 article",domProps:{"innerHTML":_vm._s(_vm.render(_vm.page.intro_text))}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }